'use client';

import { c as _c } from "react/compiler-runtime";
import { UISwitcher } from '@/comps/ui/buttons/UISwitcher/UISwitcher';
import { SegmentDimensionMappingTrigger } from '@/domains/pages/shared/segment-dimension-mapping-trigger';
import { MODEL_SAVINGS_POSITIVE_COLOR } from '@/domains/pages/model-savings/constants';
import { AIFI_DATA_NUMBER_CLASS } from '@/domains/pages/ai-proficiency/typography';
import type { ModelSavingsView, SavingsSegmentSummary } from '@/domains/pages/model-savings/types';
import { formatCompactSavingsPill } from '@/domains/pages/model-savings/utils/model-savings.utils';
import type { SegmentKind } from '@/domains/pages/ai-proficiency/utils/segment-api-payloads';
import { cn } from '@/utils/shad';
const VIEW_OPTIONS: {
  value: ModelSavingsView;
  label: string;
}[] = [{
  value: 'all',
  label: 'All'
}, {
  value: 'team',
  label: 'Team'
}, {
  value: 'market',
  label: 'Market'
}, {
  value: 'tenure',
  label: 'Tenure'
}];
type ModelSavingsScopeBarProps = {
  view: ModelSavingsView;
  onViewChange: (view: ModelSavingsView) => void;
  segments: SavingsSegmentSummary[];
  selectedSegmentName: string;
  onSelectSegment: (name: string) => void;
  className?: string;
};
export function ModelSavingsScopeBar(t0) {
  const $ = _c(15);
  const {
    view,
    onViewChange,
    segments,
    selectedSegmentName,
    onSelectSegment,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-nowrap items-center gap-2 border-b border-b-lightborder px-6 py-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = VIEW_OPTIONS.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onViewChange || $[4] !== view) {
    t3 = <UISwitcher className="max-w-max shrink-0" value={view} onChange={onViewChange} items={t2} />;
    $[3] = onViewChange;
    $[4] = view;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onSelectSegment || $[7] !== segments || $[8] !== selectedSegmentName || $[9] !== view) {
    t4 = view !== "all" && segments.length > 0 ? <><div className="h-5 w-px shrink-0 bg-border" aria-hidden={true} /><div className="no-scrollbar flex min-w-0 flex-1 flex-nowrap gap-2 overflow-x-auto" data-testid="model-savings-segment-picker">{segments.map(segment => {
          const isSelected = segment.name === selectedSegmentName;
          return <button key={segment.name} type="button" onClick={() => onSelectSegment(segment.name)} className={cn("inline-flex shrink-0 items-center gap-2 rounded-full border px-2.5 py-1 text-xs whitespace-nowrap text-foreground transition-colors", isSelected ? "border-white/60 bg-transparent" : "border-border bg-transparent hover:border-muted-foreground/50")}><span>{segment.displayName ?? segment.name}</span><span className={cn("font-medium", AIFI_DATA_NUMBER_CLASS)} style={{
              color: MODEL_SAVINGS_POSITIVE_COLOR
            }}>{formatCompactSavingsPill(segment.savingAnnual)}</span></button>;
        })}</div><SegmentDimensionMappingTrigger segmentKind={view as SegmentKind} /></> : null;
    $[6] = onSelectSegment;
    $[7] = segments;
    $[8] = selectedSegmentName;
    $[9] = view;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className={t1} data-testid="model-savings-scope-bar">{t3}{t4}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(option) {
  return {
    value: option.value,
    label: option.label
  };
}